import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../components/Loading";
import DropdownMenu from './components/Dropdown'
import _, { set, times, wrap } from 'lodash';
import RemoveSvg from '../../svgs/RemoveSvg'
import RegistrationFormData from './components/RegistrationFormData';
import EventEmail from "./components/EventEmail";
import RefreshButton from '../../svgs/RefreshButton'
import SaveButton from '../../svgs/SaveButton'
import { fetchRegistrationFormTemplateById, deleteRegistrationFormTemplate, updateRegistrationFormTemplates } from "../../services/registrationFormTemplates";
import QRCode from 'qrcode'
import { SHARE_BASE_URL } from "../../config";

const TABS = ['報名表內容', '報名數據', '電郵通知']

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();

    const [data, setData] = useState({})
    useEffect(() => {
        fetchData()
    }, [props.token])

    async function fetchData() {
        let res = await fetchRegistrationFormTemplateById(id)
        if (res.result) {
            setData(res.result)
        }
    }
    const refresh = async () => {
        fetchData()
    }


    const save = async () => {
        if (!data.name || data.name.length < 3) {
            alert('報名表名稱長度需大於3')
            return
        }
        setIsloading(true)
        let res = await updateRegistrationFormTemplates(props.token?.token, id, {
            name: data.name,
            status: data.status,
            email: data.email || {},
            order: data.order || 99,
            questions: data.questions || [],
        });
        if (res.errno) {
            alert(res.message || '更新失敗')
        } else {
            alert('更新成功')
            refresh()
        }
        setIsloading(false);
    }




    const [tab, setTab] = useState(TABS[0])
    const qrRef = useRef(null);



    const [isDeleting, setIsDeleting] = useState(false)
    const startDeleteEvent = () => { setIsDeleting(true) }
    const handleDelete = async () => {
        setIsloading(true)
        let result = await deleteRegistrationFormTemplate(props.token?.token, id)
        if (result.errno) {
            alert(result.message || '刪除失敗')
            setIsloading(false)
        } else {
            alert('刪除成功')
            navigate('/cms/registration-forms')
        }
    }

    const copyLinkToClipboard = () => {
        const link = `${SHARE_BASE_URL}/form/${id}`;
        navigator.clipboard.writeText(link).then(() => {
            alert('報名表連結已複製到剪貼板');
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }

    const [isShowQrcode, setisShowQrcode] = useState(false);
    useEffect(() => {
        const qrOptions = {
            scale: 8,
            color: {
                dark: '#000',  // Blue dots
                light: '#FFFFFF' // Transparent background
            }
        }
        if (isShowQrcode)
            QRCode.toCanvas(qrRef.current, `${SHARE_BASE_URL}/form/${id}`
                , qrOptions, function (error) {
                    if (error) console.error(error)
                })
    }, [isShowQrcode])
    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] pb-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className='p-[16px] relative rounded-[7px] w-full p-[16px] z-[2] flex flex-row'>
                <div className="flex flex-col z-[2]">
                    <div className="font-[700] text-[24px]">{data.name}</div>
                    <div className="text-[12px]">報名表管理 {'>'} {data.name}</div>
                </div>
                <div className="flex flex-row  flex-1 items-center justify-end gap-[8px] z-[2]">
                    <div onClick={startDeleteEvent} className="cursor-pointer hover:opacity-[.5]">
                        <DeleteButton />
                    </div>
                    <div onClick={save} className="cursor-pointer hover:opacity-[.5]">
                        <SaveButton />
                    </div>
                    <div onClick={refresh} className="cursor-pointer hover:opacity-[.5]">
                        <RefreshButton />
                    </div>
                    <div onClick={navigateTo('/cms/events')} className="cursor-pointer hover:opacity-[.5]">
                        <BackButton />
                    </div>
                </div>
                <div className="absolute w-full bottom-0 left-0 right-0 top-0" style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1 }} />
            </div>
            <div className="w-full flex flex-row gap-[16px] flex-wrap" style={{ borderBottom: '2px solid #fff' }}>
                {TABS.map((item, index) =>
                    <div key={item} className="flex flex-row items-center justify-center cursor-pointer mb-[-2px]" style={{ fontWeight: item === tab ? '700' : '400', fontSize: '16px', color: item === tab ? '#0F737E' : '#00000099', padding: '8px 16px', borderBottom: item === tab ? '2px solid #0F737E' : 'none' }} onClick={() => { setTab(item) }}>
                        {item}
                    </div>
                )}
            </div>

            {tab === '報名表內容' && <div className="w-full flex flex-col gap-[16px] p-[16px]">
                <div className="w-full flex flex-row gap-[16px]">
                    <div onClick={copyLinkToClipboard} className="cursor-pointer hover:opacity-[.5] px-[24px] py-[4px] rounded-[4px] text-[white] font-[700] text-[12px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>
                        複製報名表連結
                    </div>
                    <div onClick={() => { setisShowQrcode(true) }} className="cursor-pointer hover:opacity-[.5] px-[24px] py-[4px] rounded-[4px] text-[white] font-[700] text-[12px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>
                        顯示報名表二維碼
                    </div>
                </div>
                <div className="w-full gap-[16px] flex flex-row items-start justify-start flex-wrap">
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>報名表名稱</div>
                        <input value={data?.name || ''} onChange={(e) => { setData({ ...data, name: e.target.value }) }} placeholder='報名表名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>報名表狀態</div>
                        <DropdownMenu options={['已公開', '草稿']}
                            value={data?.status === 'published' ? '已公開' : '草稿'}
                            select={(item, index) => {
                                setData({ ...data, status: item === '已公開' ? 'published' : 'draft' })
                            }}
                        />
                    </div>



                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'> 顯示順序（數值越大，顯示越前）</div>
                        <input value={data?.order ?? ''} type="number" onChange={(e) => {
                            let num = parseInt(e.target.value) ?? 99
                            setData({ ...data, order: num < 0 ? 0 : num })
                        }} placeholder='顯示順序' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                </div>

                <div className='font-[700]'>報名表問題</div>
                {data?.questions?.length > 0 ? data?.questions?.map((item, index) =>
                    <div key={index} className='w-full rounded-[7px] p-[16px] flex flex-col gap-[16px] border-[2px] border-[#000]'>
                        <div className='flex flex-row items-start justify-start w-full'>
                            <div className='font-[700] text-[16px] flex-1'>問題 {index + 1}</div>
                            <div onClick={() => {
                                let questions = data?.questions || []
                                questions.splice(index, 1)
                                setData({ ...data, questions })
                            }} className='cursor-pointer hover:opacity-[.5]'>
                                <RemoveSvg />
                            </div>
                        </div>
                        <div className='flex flex-col gap-[8px] w-full max-w-[400px]'>
                            <div className='font-[700]'> 顯示在報名數據</div>
                            <DropdownMenu options={['是', '否']}
                                value={item?.isVisibleInData === true ? '是' : '否'}
                                select={(isVisibleInData, ti) => {
                                    let questions = data?.questions || []
                                    questions[index] = { ...questions[index], isVisibleInData: isVisibleInData === '是' ? true : false }
                                    setData({ ...data, questions })
                                }}
                            />
                        </div>

                        <div className='flex flex-col gap-[8px] w-full max-w-[400px]'>
                            <div className='font-[700]'>問題類型</div>
                            <DropdownMenu options={['文字問題', '單選題', '電子郵件','上傳履歷表','多選題','文字信息']}
                                value={item?.type || '文字問題'}
                                select={(type, ti) => {
                                    let questions = data?.questions || []
                                    questions[index] = { ...questions[index], type }
                                    if (type === '文字問題') {
                                        delete questions[index].options
                                    } else if (!questions[index].options || !Array.isArray(questions[index].options)) {
                                        questions[index].options = ['選項1']
                                    }
                                    setData({ ...data, questions })
                                }}
                            />
                        </div>
                        <div className='flex flex-col gap-[8px] w-full max-w-[600px]'>
                            <div className='font-[700]'>{item?.type==='文字信息'?'文字信息':'問題內容'}</div>
                            <input value={item?.question || ''} onChange={(e) => {
                                let questions = data?.questions || []
                                questions[index] = { ...questions[index], question: e.target.value }
                                setData({ ...data, questions })
                            }} placeholder='問題內容' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                        </div>
                        <div className='flex flex-col gap-[8px] w-full max-w-[600px]'>
                            <div className='font-[700]'>問題小提示</div>
                            <input value={item?.hint || ''} onChange={(e) => {
                                let questions = data?.questions || []
                                questions[index] = { ...questions[index], hint: e.target.value }
                                setData({ ...data, questions })
                            }} placeholder='問題小提示' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                        </div>


                        {((item?.type === '單選題')|| (item?.type === '多選題')) && <div className='flex flex-col gap-[8px] w-full max-w-[600px]'>
                            <div className='font-[700]'>選項內容</div>
                            {item?.options?.length > 0 ? item?.options?.map((option, oi) =>
                                <div key={oi} className='flex flex-row items-center justify-start gap-[8px]'>
                                    <div className='text-[16px]'>{oi + 1}.</div>
                                    <input value={option || ''} onChange={(e) => {
                                        let questions = data?.questions || []
                                        let options = questions[index]?.options || []
                                        options[oi] = e.target.value
                                        questions[index] = { ...questions[index], options }
                                        setData({ ...data, questions })
                                    }} placeholder='選項內容' className='rounded-[7px] px-[8px] py-[4px] font-[400] min-w-[400px]' />
                                    <div onClick={() => {
                                        let questions = data?.questions || []
                                        let options = questions[index]?.options || []
                                        options.splice(oi, 1)
                                        questions[index] = { ...questions[index], options }
                                        setData({ ...data, questions })
                                    }} className='cursor-pointer hover:opacity-[.5]'>
                                        <RemoveSvg />
                                    </div>
                                </div>
                            ) : <div>無選項，請新增</div>}
                            <button onClick={() => {
                                let questions = data?.questions || []
                                let options = questions[index]?.options || []
                                options.push(`選項${options.length + 1}`)
                                questions[index] = { ...questions[index], options }
                                setData({ ...data, questions })
                            }} className='bg-[#0F737E] text-[white] rounded-[99px] text-[14px] font-[700] p-[8px] px-[16px] flex flex-row items-center justify-center w-[120px]'>新增選項</button>
                        </div>}
                        {item?.type === '電子郵件' &&
                            <div>此問題將會驗證填寫的內容是否為有效的電郵地址並用於發送電子郵</div>
                        }
                        <div className='flex flex-row items-center justify-start gap-[8px]'>
                            <input type="checkbox" checked={item?.isRequired || false} onChange={(e) => {
                                let questions = data?.questions || []
                                questions[index] = { ...questions[index], isRequired: e.target.checked }
                                setData({ ...data, questions })
                            }} />
                            <div className='font-[700]'>必填問題</div>
                        </div>
                    </div>
                ) : <div>尚無問題，請新增</div>}
                <button onClick={() => {
                    let questions = data?.questions || []
                    questions.push({ type: '文字問題', question: '', isRequired: false })
                    setData({ ...data, questions })
                }} className='bg-[#0F737E] text-[white] rounded-[99px] text-[14px] font-[700] p-[8px] px-[16px] flex flex-row items-center justify-center w-[120px]'>新增問題</button>


            </div>}



            {tab === '電郵通知' && <EventEmail data={data} refresh={refresh} onEdit={(key, value) => { setData({ ...data, [key]: value }) }} type='register' />}
            {tab === '報名數據' && <RegistrationFormData />}


            {isDeleting && <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000099] z-[100] flex items-center justify-center">
                <div className="bg-white p-[24px] rounded-[7px] flex flex-col items-center justify-center gap-[24px]">
                    <div className="text-[16px] font-bold">確定要刪除這個報名表嗎？</div>
                    <div className="text-[14px]">刪除後將無法恢復，請謹慎操作。</div>
                    <div className="flex flex-row items-center justify-center gap-[8px]">
                        <div onClick={() => { setIsDeleting(false) }} className="cursor-pointer text-[#938474] bg-[#eee] px-[16px] rounded-[8px] hover:opacity-[.5]">取消</div>
                        <div onClick={handleDelete} className="cursor-pointer text-red-500 hover:opacity-[.5] px-[16px]">刪除</div>
                    </div>
                </div>
            </div>}
            {isloading && <LoadingPage />}
            {isShowQrcode &&
                <div className="fixed top-0 left-0 w-full h-full bg-[#00000080] flex items-center justify-center z-[9999]">
                    <div className="bg-white max-w-[90%] max-h-[90%] overflow-y-auto relative rounded-[8px]">
                        <div className="p-[16px]">
                            <div className="font-bold text-[24px] mb-[16px]">
                                報名表二維碼
                            </div>
                            <div className="mb-[16px]">
                                掃描以下二維碼以訪問報名表:
                            </div>
                            <div className="flex items-center justify-center mb-[16px]">
                                <div className='flex flex-col bg-white text-black text-[12px] items-center font-bold pb-[24px]'>
                                    <canvas ref={qrRef} />
                                </div>
                            </div>
                            <div className="text-[14px] mb-[16px]">
                                您可以將此二維碼保存或打印出來，方便參加者掃描。
                            </div>
                            <button className="px-[16px] py-[8px] bg-[#0F737E] text-white rounded-[4px] font-bold mb-[16px]"
                                onClick={() => {
                                    const canvas = qrRef.current;
                                    if (!canvas) return;
                                    canvas.toBlob((blob) => {
                                        const link = document.createElement('a');
                                        link.href = URL.createObjectURL(blob);
                                        link.download = `registration-form-${id}.png`;
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                    }, 'image/png');
                                }}
                            >
                                儲存二維碼
                            </button>
                            <div className="flex items-center justify-end">
                                <button className="px-[16px] py-[8px] bg-[#0F737E] text-white rounded-[4px] font-bold"
                                    onClick={() => {
                                        QRCode.toCanvas(qrRef.current, `${SHARE_BASE_URL}/form/${id}`, { errorCorrectionLevel: 'H' })
                                            .then(() => {
                                                setisShowQrcode(false);
                                            })
                                            .catch(err => {
                                                console.error('Error generating QR code:', err);
                                            });
                                    }}
                                >
                                    關閉
                                </button>
                            </div>
                        </div>
                        <div className="absolute top-0 right-0 p-[8px] cursor-pointer z-[10]" onClick={() => { setisShowQrcode(false) }}>X</div>
                    </div>
                </div>
            }
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)


const DeleteButton = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={164}
        height={39}
        fill="none"
        {...props}
    >
        <rect width={164} height={39} fill="url(#adelete)" rx={7} />
        <text
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            fill="#fff"
            fontSize={16}
            fontWeight="bold"
            fontFamily="Arial, sans-serif"
        >
            刪除報名表
        </text>
        <defs>
            <linearGradient
                id="adelete"
                x1={82}
                x2={82}
                y1={0}
                y2={39}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8C706B" />
                <stop offset={1} stopColor="#8C706B" stopOpacity={0.2} />
            </linearGradient>
        </defs>
    </svg>
)

const BackButton = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={129}
        height={40}
        fill="none"
        {...props}
    >
        <rect width={129} height={40} fill="url(#aback)" rx={7} />
        <path
            fill="#fff"
            d="M46.648 14.578h3.555c1.521 0 2.672.214 3.453.64.782.428 1.172 1.178 1.172 2.25 0 .433-.07.824-.21 1.173a2.122 2.122 0 0 1-.595.859c-.26.224-.578.37-.953.438v.078c.38.078.724.213 1.032.406.307.187.552.463.734.828.187.36.281.838.281 1.438 0 .692-.17 1.286-.508 1.78-.338.495-.823.876-1.453 1.141-.625.26-1.37.391-2.234.391h-4.274V14.578Zm2.422 4.524h1.407c.703 0 1.19-.11 1.46-.329.271-.224.407-.552.407-.984 0-.437-.162-.75-.485-.937-.317-.193-.823-.29-1.515-.29H49.07v2.54Zm0 1.921V24h1.578c.73 0 1.237-.14 1.524-.422.286-.281.43-.659.43-1.133 0-.28-.063-.528-.188-.742-.125-.213-.336-.38-.633-.5-.291-.12-.695-.18-1.21-.18h-1.5Zm11.72-3.937c1.17 0 2.07.255 2.694.766.625.51.938 1.286.938 2.328V26h-1.664l-.461-1.188h-.063c-.25.313-.505.568-.765.766-.26.198-.56.344-.899.438-.338.093-.75.14-1.234.14-.516 0-.98-.099-1.39-.297a2.208 2.208 0 0 1-.962-.906c-.234-.411-.351-.932-.351-1.562 0-.927.325-1.61.976-2.047.651-.443 1.628-.688 2.93-.735l1.516-.047v-.382c0-.459-.12-.795-.36-1.008-.24-.214-.573-.32-1-.32-.422 0-.836.06-1.242.18a9.63 9.63 0 0 0-1.219.452l-.789-1.609A6.775 6.775 0 0 1 59 17.297a7.539 7.539 0 0 1 1.79-.211Zm1.265 4.867-.922.031c-.771.021-1.308.16-1.61.414-.296.256-.445.592-.445 1.008 0 .365.107.625.32.782.214.15.493.226.836.226.51 0 .94-.151 1.29-.453.354-.302.53-.732.53-1.29v-.718Zm8.375 4.203c-.865 0-1.602-.156-2.211-.468-.61-.318-1.073-.808-1.39-1.47-.319-.66-.477-1.507-.477-2.538 0-1.068.18-1.938.539-2.61.364-.677.867-1.174 1.507-1.492.646-.318 1.394-.476 2.243-.476.604 0 1.125.06 1.562.18a6.08 6.08 0 0 1 1.156.413l-.703 1.844a11.095 11.095 0 0 0-1.047-.367 3.29 3.29 0 0 0-.968-.149c-.417 0-.763.1-1.04.297-.275.193-.481.485-.617.875-.135.39-.203.88-.203 1.47 0 .577.073 1.056.219 1.437.146.38.357.664.633.851.276.182.612.274 1.008.274.494 0 .934-.066 1.32-.196.385-.135.76-.323 1.125-.562v2.039c-.365.229-.748.393-1.148.492-.396.104-.899.156-1.508.156Zm7.07-12.312v5.437c0 .328-.013.657-.04.985-.025.328-.054.656-.085.984h.031c.162-.23.326-.456.492-.68.172-.224.355-.44.547-.648l2.446-2.656h2.687l-3.469 3.789L83.79 26h-2.75l-2.516-3.54-1.023.821V26h-2.383V13.844H77.5Z"
        />
        <defs>
            <linearGradient
                id="aback"
                x1={64.5}
                x2={64.5}
                y1={0}
                y2={40}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8C866B" />
                <stop offset={1} stopColor="#8C866B" stopOpacity={0.2} />
            </linearGradient>
        </defs>
    </svg>
)